document.addEventListener("DOMContentLoaded", function() {
  const freeShippingThreshold = 100; // Monto mínimo para envío gratuito en euros

  // Función para actualizar mensaje
  function updateFreeShippingMessage(cartTotal) {
    const messageContainer = document.querySelector("#free-shipping-message");
    const amountNeeded = (freeShippingThreshold - cartTotal).toFixed(2);

    if (!messageContainer) return;

    if (cartTotal >= freeShippingThreshold) {
      messageContainer.innerHTML = "Tu pedido se envía GRATIS dentro de España";
      messageContainer.style.display = "block"; // Asegurar que se muestre
    } else {
      messageContainer.innerHTML = `Añade ${amountNeeded}€ para envío GRATIS dentro de España`;
      messageContainer.style.display = "block";
    }
  }

  // Función para obtener y actualizar el total del carrito
  function refreshCartMessage() {
    fetch("/cart.js")
      .then(response => response.json())
      .then(cart => {
        const totalInEuros = cart.total_price / 100; // Convertir de centavos a euros
        updateFreeShippingMessage(totalInEuros);
      });
  }

  // Inicialmente, obtenemos el total del carrito
  refreshCartMessage();

  // Escuchar cambios en el carrito usando eventos estándar de Shopify
  document.addEventListener("cart:updated", refreshCartMessage);
  
  // También escuchar otros eventos comunes del carrito
  document.addEventListener("cart:refresh", refreshCartMessage);
  
  // Para temas que usan fetch API para actualizar carrito
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    return originalFetch.apply(this, args).then(response => {
      if (args[0] && args[0].includes('/cart/')) {
        setTimeout(refreshCartMessage, 100); // Pequeño delay para asegurar actualización
      }
      return response;
    });
  };
});
